var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"loading-mask",style:({ background: _vm.background })},[_c('LoadingIcon',{style:({ fontSize: _vm.size, color: _vm.color })})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }